import { useEffect } from "react";

const APP_TITLE = "Πλατφόρμα διαχείρισης αθλητικών εισιτηρίων";

export default function useDocumentTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} | ${APP_TITLE}` : APP_TITLE;
  }, [pageTitle]);
}
